(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["quiz"]) return;
  try {
    
if ( document.readyState === "complete" || (document.readyState !== "loading" && !document.documentElement.doScroll)) {
		if(document.querySelector('.main_header_wrapper') !== null){
			document.querySelector('.main_header_wrapper').classList.add("transparent_header");
		}
            loadQuiz();
        } else {
            document.addEventListener("DOMContentLoaded", loadQuiz);
        }
        function loadQuiz(){
            var answers = document.querySelectorAll('.answers a');
            var navigation = document.querySelectorAll('.quiz-section .go-to');
            var selectedAnswers = [];

            for(var x = 0; x < answers.length; x++) {
                answers[x].addEventListener("click", function(e){
                    e.preventDefault();
                    _answerQuestion(e.currentTarget);
                    return false;
                });
            }

            for(var y = 0; y < navigation.length; y++) {
                navigation[y].addEventListener("click", function(e){
                    e.preventDefault();
                    _goTo(this.getAttribute("data-panel"));
                    return false;
                });
            }

            function _answerQuestion(elm) {
                var a = elm.getAttribute("data-answer");
                var q = elm.getAttribute("data-question");
                selectedAnswers[parseInt(q)] = a; 
				if(document.querySelector('.question.q'+q+' .answers a.active') !== null){
                	document.querySelector('.question.q'+q+' .answers a.active').classList.remove("active");
				}
				elm.classList.add("active");
                _showNextLink(q);
            }

            function _showNextLink(current) {
				if(document.querySelector('.question.q'+current+' .quiz-nav a.hidden') !== null){
                	document.querySelector('.question.q'+current+' .quiz-nav a.hidden').classList.remove("hidden");
				}
            }

            function _goTo(question) {
                if (question === 'finish') {
                    var filtered = selectedAnswers.filter(function (el) {
                      return el != null && el != "";
                    });
                    var search = new URLSearchParams(); 
                        search.set('type', filtered.join(','));


                    location.href = "/pages/coffee-quiz-results?" + search.toString();

                }
                else {
					if(document.querySelector('.transparent_header') !== null){
						document.querySelector('.transparent_header').classList.remove("transparent_header");
					}
                    document.querySelector('.quiz-section.visible').classList.remove('visible');
                    document.querySelector('.quiz-section.q' + question).classList.add('visible');
                }
            }
        }

  } catch(e) { console.error(e); }
})();
})();
